/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from 'prop-types';
import { useState } from 'react';
import Link from 'next/link';
import parse from 'html-react-parser';
import styles from './subNavBar.module.scss';
import HelpCenterSearch from '../helpCenterSearch/helpCenterSearch';

export default function SubNavBar({
  items = [],
  maxItemsPerRow = null,
  searchUrl = '',
  offset = 0,
}) {
  const [isOpen, toggleOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isdropdownActive, setIsDropdownActive] = useState(false);
  const [activeSub, setActiveSub] = useState(null);
  const [dropdownActiveSub, setDropdownActiveSub] = useState(null);
  const status = isOpen ? styles.close : styles.open;
  const handleClick = (e, index, link) => {
    if (link && link.startsWith('#')) {
      e.preventDefault();
      const id = link.substring(1);
      if (id && document.getElementById(id) != null) {
        window.scrollTo({
          behavior: 'smooth',
          top: document.getElementById(id).offsetTop - 72 + offset,
        });
      }
    }
    setActiveSub(index);
    setIsActive(true);
    setIsDropdownActive(false);
  };
  const handleDropdownClick = (e, index, link) => {
    if (link.startsWith('#')) {
      e.preventDefault();
      const id = link.substring(1);
      if (document.getElementById(id) != null) {
        window.scrollTo({
          behavior: 'smooth',
          top: document.getElementById(id).offsetTop - 72 + offset,
        });
      }
    }
    setIsDropdownActive(true);
    setDropdownActiveSub(index);
    setIsActive(false);
    toggleOpen(!isOpen);
  };

  const renderDropdownItems = (dropdownItems) => {
    return (
      <nav
        className={`${styles.dropdownMenu} ${
          maxItemsPerRow ? styles.dropdownModal : ''
        }`}
      >
        <ul>
          {dropdownItems?.map((menu, index) => (
            <li
              key={`${menu.link}`}
              className={`${styles.dropdownItem} ${
                dropdownActiveSub === index && isdropdownActive && styles.active
              } `}
            >
              <Link
                href={`${menu?.link}`}
                data-testid={menu.link.startsWith('#') ? '' : menu.link}
                onClick={(e) => handleDropdownClick(e, index, menu.link)}
              >
                {parse(menu?.label)}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    );
  };
  const visibleChildren =
    (maxItemsPerRow && items?.slice(0, maxItemsPerRow)) || items;

  return (
    <div className={styles.wrapper}>
      <div className={styles.navBar}>
        <nav
          className={styles.subnavBar}
          onClick={(e) => {
            e.preventDefault();
            toggleOpen((isOpenState) => !isOpenState);
          }}
        >
          <ul className={`${styles.list} `}>
            {visibleChildren?.map((menu, index) => {
              const key = `menu-${index}`;
              return (
                <li
                  className={`${styles.navigation} ${
                    activeSub === index && isActive && styles.active
                  }`}
                  key={key}
                >
                  <Link
                    href={`${menu?.link.startsWith('#') ? '' : menu?.link}`}
                    data-testid={menu?.link}
                    onClick={(e) => {
                      handleClick(e, index, menu?.link);
                    }}
                  >
                    {parse(menu?.label)}
                  </Link>
                </li>
              );
            })}
          </ul>
          {maxItemsPerRow && items?.length > maxItemsPerRow ? (
            <div
              data-testid="menu-icon"
              role="button"
              className={`${status} ${styles.icon} ${
                maxItemsPerRow ? styles.showIcon : ''
              }`}
              aria-hidden="true"
            />
          ) : null}
        </nav>
        {searchUrl && (
          <HelpCenterSearch
            className={styles.search}
            placeholder="Search"
            onEnter={(query) => {
              window.location.assign(`${searchUrl}?query=${query}`);
            }}
          />
        )}
      </div>
      {maxItemsPerRow &&
        isOpen &&
        renderDropdownItems(items?.slice(maxItemsPerRow))}
    </div>
  );
}

SubNavBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
    })
  ),
  maxItemsPerRow: PropTypes.number,
  searchUrl: PropTypes.string,
  offset: PropTypes.number,
};
